export default "__VITE_ASSET__0f06e70b__"